import React, { useState, useEffect } from "react";
import CenterUI from "./CenterUI";
import MobileWarningModal from "./MobileWarningModal";
import IsRoot from "./IsRoot";
import ConfigureStyles from "./ConfigureStyles";

function AppConfig() {
  const filePath = window.jsonFile;
  let [jsonData, setJsonData] = useState(false);

  useEffect(() => {
    async function fetchConfig(url = filePath) {
      try {
        const response = await fetch(url);
        const data = await response.json();
        return data;
      } catch (error) {
        console.error(`Error fetching config:${url}`, error);
      }
    }

    async function loadConfig() {
      const config = await fetchConfig(filePath);
      let defaultTheme = `./themes/defaultTheme.json`;
      if (config) {
        window.AppConfig = config;
        if (IsRoot()) {
          // Modify initalUrl if not in root
          window.AppConfig.initalUrl = "." + window.AppConfig.initalUrl; // Adding this goes up one Dir level
          window.AppConfig.themeUrl = "." + window.AppConfig.themeUrl; // Adding this goes up one Dir level
          defaultTheme = "." + defaultTheme;
        }
        const theme = await fetchConfig(window.AppConfig.themeUrl);
        const themeDefault = await fetchConfig(defaultTheme);
        ConfigureStyles(config, theme, themeDefault);
        if (theme.custom) {
          // remnoves custom items so leva doesnt freakout
          delete theme.custom;
        }
        if (config) {
          window.AppConfig.theme = theme;
        }
        setJsonData(true);
        console.log(window.AppConfig);
        console.log("all json data loaded");
        console.log("");
      }
    }

    loadConfig();
  }, []);

  return <>{jsonData && <MobileWarningModal config={window.AppConfig} />}</>; // mobile warnign before content load
  // return <>{jsonData && <CenterUI config = {window.AppConfig} />}</>;

  
}
export default AppConfig;
